const S36_CotyledonHeatMap = {
    "x_labels": [
        "DAP12_1",
        "DAP12_2",
        "DAP12_3",
        "DAP15_1",
        "DAP15_2",
        "DAP15_3",
        "DAP18_1",
        "DAP18_2",
        "DAP18_3",
        "DAP21_1",
        "DAP21_2",
        "DAP21_3",
        "DAP24_1",
        "DAP24_2",
        "DAP24_3",
        "DAP6_1",
        "DAP6_2",
        "DAP6_3",
        "DAP9_1",
        "DAP9_2",
        "DAP9_3"
    ],
    "y_labels": [
        "DAP12_1",
        "DAP12_2",
        "DAP12_3",
        "DAP15_1",
        "DAP15_2",
        "DAP15_3",
        "DAP18_1",
        "DAP18_2",
        "DAP18_3",
        "DAP21_1",
        "DAP21_2",
        "DAP21_3",
        "DAP24_1",
        "DAP24_2",
        "DAP24_3",
        "DAP6_1",
        "DAP6_2",
        "DAP6_3",
        "DAP9_1",
        "DAP9_2",
        "DAP9_3"
    ],
    "data": [
        [
            0,
            0,
            1.0
        ],
        [
            1,
            0,
            0.87
        ],
        [
            2,
            0,
            0.83
        ],
        [
            3,
            0,
            0.873
        ],
        [
            4,
            0,
            0.88
        ],
        [
            5,
            0,
            0.781
        ],
        [
            6,
            0,
            0.634
        ],
        [
            7,
            0,
            0.61
        ],
        [
            8,
            0,
            0.607
        ],
        [
            9,
            0,
            0.463
        ],
        [
            10,
            0,
            0.459
        ],
        [
            11,
            0,
            0.402
        ],
        [
            12,
            0,
            0.312
        ],
        [
            13,
            0,
            0.334
        ],
        [
            14,
            0,
            0.298
        ],
        [
            15,
            0,
            0.769
        ],
        [
            16,
            0,
            0.776
        ],
        [
            17,
            0,
            0.716
        ],
        [
            18,
            0,
            0.894
        ],
        [
            19,
            0,
            0.896
        ],
        [
            20,
            0,
            0.898
        ],
        [
            0,
            1,
            0.87
        ],
        [
            1,
            1,
            1.0
        ],
        [
            2,
            1,
            0.859
        ],
        [
            3,
            1,
            0.777
        ],
        [
            4,
            1,
            0.783
        ],
        [
            5,
            1,
            0.795
        ],
        [
            6,
            1,
            0.566
        ],
        [
            7,
            1,
            0.528
        ],
        [
            8,
            1,
            0.536
        ],
        [
            9,
            1,
            0.414
        ],
        [
            10,
            1,
            0.412
        ],
        [
            11,
            1,
            0.438
        ],
        [
            12,
            1,
            0.287
        ],
        [
            13,
            1,
            0.306
        ],
        [
            14,
            1,
            0.276
        ],
        [
            15,
            1,
            0.692
        ],
        [
            16,
            1,
            0.699
        ],
        [
            17,
            1,
            0.736
        ],
        [
            18,
            1,
            0.804
        ],
        [
            19,
            1,
            0.81
        ],
        [
            20,
            1,
            0.812
        ],
        [
            0,
            2,
            0.83
        ],
        [
            1,
            2,
            0.859
        ],
        [
            2,
            2,
            1.0
        ],
        [
            3,
            2,
            0.747
        ],
        [
            4,
            2,
            0.749
        ],
        [
            5,
            2,
            0.771
        ],
        [
            6,
            2,
            0.545
        ],
        [
            7,
            2,
            0.507
        ],
        [
            8,
            2,
            0.521
        ],
        [
            9,
            2,
            0.399
        ],
        [
            10,
            2,
            0.398
        ],
        [
            11,
            2,
            0.439
        ],
        [
            12,
            2,
            0.274
        ],
        [
            13,
            2,
            0.29
        ],
        [
            14,
            2,
            0.262
        ],
        [
            15,
            2,
            0.646
        ],
        [
            16,
            2,
            0.65
        ],
        [
            17,
            2,
            0.687
        ],
        [
            18,
            2,
            0.759
        ],
        [
            19,
            2,
            0.77
        ],
        [
            20,
            2,
            0.771
        ],
        [
            0,
            3,
            0.873
        ],
        [
            1,
            3,
            0.777
        ],
        [
            2,
            3,
            0.747
        ],
        [
            3,
            3,
            1.0
        ],
        [
            4,
            3,
            0.962
        ],
        [
            5,
            3,
            0.845
        ],
        [
            6,
            3,
            0.825
        ],
        [
            7,
            3,
            0.797
        ],
        [
            8,
            3,
            0.794
        ],
        [
            9,
            3,
            0.638
        ],
        [
            10,
            3,
            0.633
        ],
        [
            11,
            3,
            0.533
        ],
        [
            12,
            3,
            0.429
        ],
        [
            13,
            3,
            0.461
        ],
        [
            14,
            3,
            0.407
        ],
        [
            15,
            3,
            0.6
        ],
        [
            16,
            3,
            0.604
        ],
        [
            17,
            3,
            0.552
        ],
        [
            18,
            3,
            0.713
        ],
        [
            19,
            3,
            0.715
        ],
        [
            20,
            3,
            0.722
        ],
        [
            0,
            4,
            0.88
        ],
        [
            1,
            4,
            0.783
        ],
        [
            2,
            4,
            0.749
        ],
        [
            3,
            4,
            0.962
        ],
        [
            4,
            4,
            1.0
        ],
        [
            5,
            4,
            0.842
        ],
        [
            6,
            4,
            0.811
        ],
        [
            7,
            4,
            0.788
        ],
        [
            8,
            4,
            0.783
        ],
        [
            9,
            4,
            0.628
        ],
        [
            10,
            4,
            0.623
        ],
        [
            11,
            4,
            0.524
        ],
        [
            12,
            4,
            0.424
        ],
        [
            13,
            4,
            0.455
        ],
        [
            14,
            4,
            0.402
        ],
        [
            15,
            4,
            0.615
        ],
        [
            16,
            4,
            0.618
        ],
        [
            17,
            4,
            0.565
        ],
        [
            18,
            4,
            0.727
        ],
        [
            19,
            4,
            0.729
        ],
        [
            20,
            4,
            0.737
        ],
        [
            0,
            5,
            0.781
        ],
        [
            1,
            5,
            0.795
        ],
        [
            2,
            5,
            0.771
        ],
        [
            3,
            5,
            0.845
        ],
        [
            4,
            5,
            0.842
        ],
        [
            5,
            5,
            1.0
        ],
        [
            6,
            5,
            0.706
        ],
        [
            7,
            5,
            0.662
        ],
        [
            8,
            5,
            0.68
        ],
        [
            9,
            5,
            0.537
        ],
        [
            10,
            5,
            0.537
        ],
        [
            11,
            5,
            0.544
        ],
        [
            12,
            5,
            0.371
        ],
        [
            13,
            5,
            0.392
        ],
        [
            14,
            5,
            0.35
        ],
        [
            15,
            5,
            0.542
        ],
        [
            16,
            5,
            0.543
        ],
        [
            17,
            5,
            0.575
        ],
        [
            18,
            5,
            0.638
        ],
        [
            19,
            5,
            0.647
        ],
        [
            20,
            5,
            0.648
        ],
        [
            0,
            6,
            0.634
        ],
        [
            1,
            6,
            0.566
        ],
        [
            2,
            6,
            0.545
        ],
        [
            3,
            6,
            0.825
        ],
        [
            4,
            6,
            0.811
        ],
        [
            5,
            6,
            0.706
        ],
        [
            6,
            6,
            1.0
        ],
        [
            7,
            6,
            0.959
        ],
        [
            8,
            6,
            0.953
        ],
        [
            9,
            6,
            0.869
        ],
        [
            10,
            6,
            0.867
        ],
        [
            11,
            6,
            0.699
        ],
        [
            12,
            6,
            0.609
        ],
        [
            13,
            6,
            0.648
        ],
        [
            14,
            6,
            0.568
        ],
        [
            15,
            6,
            0.402
        ],
        [
            16,
            6,
            0.406
        ],
        [
            17,
            6,
            0.364
        ],
        [
            18,
            6,
            0.49
        ],
        [
            19,
            6,
            0.482
        ],
        [
            20,
            6,
            0.497
        ],
        [
            0,
            7,
            0.61
        ],
        [
            1,
            7,
            0.528
        ],
        [
            2,
            7,
            0.507
        ],
        [
            3,
            7,
            0.797
        ],
        [
            4,
            7,
            0.788
        ],
        [
            5,
            7,
            0.662
        ],
        [
            6,
            7,
            0.959
        ],
        [
            7,
            7,
            1.0
        ],
        [
            8,
            7,
            0.959
        ],
        [
            9,
            7,
            0.881
        ],
        [
            10,
            7,
            0.877
        ],
        [
            11,
            7,
            0.678
        ],
        [
            12,
            7,
            0.62
        ],
        [
            13,
            7,
            0.661
        ],
        [
            14,
            7,
            0.578
        ],
        [
            15,
            7,
            0.392
        ],
        [
            16,
            7,
            0.397
        ],
        [
            17,
            7,
            0.345
        ],
        [
            18,
            7,
            0.477
        ],
        [
            19,
            7,
            0.468
        ],
        [
            20,
            7,
            0.486
        ],
        [
            0,
            8,
            0.607
        ],
        [
            1,
            8,
            0.536
        ],
        [
            2,
            8,
            0.521
        ],
        [
            3,
            8,
            0.794
        ],
        [
            4,
            8,
            0.783
        ],
        [
            5,
            8,
            0.68
        ],
        [
            6,
            8,
            0.953
        ],
        [
            7,
            8,
            0.959
        ],
        [
            8,
            8,
            1.0
        ],
        [
            9,
            8,
            0.881
        ],
        [
            10,
            8,
            0.876
        ],
        [
            11,
            8,
            0.701
        ],
        [
            12,
            8,
            0.625
        ],
        [
            13,
            8,
            0.664
        ],
        [
            14,
            8,
            0.584
        ],
        [
            15,
            8,
            0.386
        ],
        [
            16,
            8,
            0.389
        ],
        [
            17,
            8,
            0.347
        ],
        [
            18,
            8,
            0.473
        ],
        [
            19,
            8,
            0.466
        ],
        [
            20,
            8,
            0.482
        ],
        [
            0,
            9,
            0.463
        ],
        [
            1,
            9,
            0.414
        ],
        [
            2,
            9,
            0.399
        ],
        [
            3,
            9,
            0.638
        ],
        [
            4,
            9,
            0.628
        ],
        [
            5,
            9,
            0.537
        ],
        [
            6,
            9,
            0.869
        ],
        [
            7,
            9,
            0.881
        ],
        [
            8,
            9,
            0.881
        ],
        [
            9,
            9,
            1.0
        ],
        [
            10,
            9,
            0.969
        ],
        [
            11,
            9,
            0.758
        ],
        [
            12,
            9,
            0.791
        ],
        [
            13,
            9,
            0.828
        ],
        [
            14,
            9,
            0.744
        ],
        [
            15,
            9,
            0.282
        ],
        [
            16,
            9,
            0.285
        ],
        [
            17,
            9,
            0.254
        ],
        [
            18,
            9,
            0.352
        ],
        [
            19,
            9,
            0.344
        ],
        [
            20,
            9,
            0.361
        ],
        [
            0,
            10,
            0.459
        ],
        [
            1,
            10,
            0.412
        ],
        [
            2,
            10,
            0.398
        ],
        [
            3,
            10,
            0.633
        ],
        [
            4,
            10,
            0.623
        ],
        [
            5,
            10,
            0.537
        ],
        [
            6,
            10,
            0.867
        ],
        [
            7,
            10,
            0.877
        ],
        [
            8,
            10,
            0.876
        ],
        [
            9,
            10,
            0.969
        ],
        [
            10,
            10,
            1.0
        ],
        [
            11,
            10,
            0.767
        ],
        [
            12,
            10,
            0.8
        ],
        [
            13,
            10,
            0.832
        ],
        [
            14,
            10,
            0.754
        ],
        [
            15,
            10,
            0.278
        ],
        [
            16,
            10,
            0.281
        ],
        [
            17,
            10,
            0.251
        ],
        [
            18,
            10,
            0.347
        ],
        [
            19,
            10,
            0.34
        ],
        [
            20,
            10,
            0.356
        ],
        [
            0,
            11,
            0.402
        ],
        [
            1,
            11,
            0.438
        ],
        [
            2,
            11,
            0.439
        ],
        [
            3,
            11,
            0.533
        ],
        [
            4,
            11,
            0.524
        ],
        [
            5,
            11,
            0.544
        ],
        [
            6,
            11,
            0.699
        ],
        [
            7,
            11,
            0.678
        ],
        [
            8,
            11,
            0.701
        ],
        [
            9,
            11,
            0.758
        ],
        [
            10,
            11,
            0.767
        ],
        [
            11,
            11,
            1.0
        ],
        [
            12,
            11,
            0.631
        ],
        [
            13,
            11,
            0.652
        ],
        [
            14,
            11,
            0.599
        ],
        [
            15,
            11,
            0.239
        ],
        [
            16,
            11,
            0.241
        ],
        [
            17,
            11,
            0.268
        ],
        [
            18,
            11,
            0.299
        ],
        [
            19,
            11,
            0.301
        ],
        [
            20,
            11,
            0.311
        ],
        [
            0,
            12,
            0.312
        ],
        [
            1,
            12,
            0.287
        ],
        [
            2,
            12,
            0.274
        ],
        [
            3,
            12,
            0.429
        ],
        [
            4,
            12,
            0.424
        ],
        [
            5,
            12,
            0.371
        ],
        [
            6,
            12,
            0.609
        ],
        [
            7,
            12,
            0.62
        ],
        [
            8,
            12,
            0.625
        ],
        [
            9,
            12,
            0.791
        ],
        [
            10,
            12,
            0.8
        ],
        [
            11,
            12,
            0.631
        ],
        [
            12,
            12,
            1.0
        ],
        [
            13,
            12,
            0.964
        ],
        [
            14,
            12,
            0.964
        ],
        [
            15,
            12,
            0.197
        ],
        [
            16,
            12,
            0.199
        ],
        [
            17,
            12,
            0.179
        ],
        [
            18,
            12,
            0.241
        ],
        [
            19,
            12,
            0.236
        ],
        [
            20,
            12,
            0.249
        ],
        [
            0,
            13,
            0.334
        ],
        [
            1,
            13,
            0.306
        ],
        [
            2,
            13,
            0.29
        ],
        [
            3,
            13,
            0.461
        ],
        [
            4,
            13,
            0.455
        ],
        [
            5,
            13,
            0.392
        ],
        [
            6,
            13,
            0.648
        ],
        [
            7,
            13,
            0.661
        ],
        [
            8,
            13,
            0.664
        ],
        [
            9,
            13,
            0.828
        ],
        [
            10,
            13,
            0.832
        ],
        [
            11,
            13,
            0.652
        ],
        [
            12,
            13,
            0.964
        ],
        [
            13,
            13,
            1.0
        ],
        [
            14,
            13,
            0.955
        ],
        [
            15,
            13,
            0.21
        ],
        [
            16,
            13,
            0.212
        ],
        [
            17,
            13,
            0.189
        ],
        [
            18,
            13,
            0.259
        ],
        [
            19,
            13,
            0.252
        ],
        [
            20,
            13,
            0.267
        ],
        [
            0,
            14,
            0.298
        ],
        [
            1,
            14,
            0.276
        ],
        [
            2,
            14,
            0.262
        ],
        [
            3,
            14,
            0.407
        ],
        [
            4,
            14,
            0.402
        ],
        [
            5,
            14,
            0.35
        ],
        [
            6,
            14,
            0.568
        ],
        [
            7,
            14,
            0.578
        ],
        [
            8,
            14,
            0.584
        ],
        [
            9,
            14,
            0.744
        ],
        [
            10,
            14,
            0.754
        ],
        [
            11,
            14,
            0.599
        ],
        [
            12,
            14,
            0.964
        ],
        [
            13,
            14,
            0.955
        ],
        [
            14,
            14,
            1.0
        ],
        [
            15,
            14,
            0.188
        ],
        [
            16,
            14,
            0.19
        ],
        [
            17,
            14,
            0.172
        ],
        [
            18,
            14,
            0.23
        ],
        [
            19,
            14,
            0.226
        ],
        [
            20,
            14,
            0.239
        ],
        [
            0,
            15,
            0.769
        ],
        [
            1,
            15,
            0.692
        ],
        [
            2,
            15,
            0.646
        ],
        [
            3,
            15,
            0.6
        ],
        [
            4,
            15,
            0.615
        ],
        [
            5,
            15,
            0.542
        ],
        [
            6,
            15,
            0.402
        ],
        [
            7,
            15,
            0.392
        ],
        [
            8,
            15,
            0.386
        ],
        [
            9,
            15,
            0.282
        ],
        [
            10,
            15,
            0.278
        ],
        [
            11,
            15,
            0.239
        ],
        [
            12,
            15,
            0.197
        ],
        [
            13,
            15,
            0.21
        ],
        [
            14,
            15,
            0.188
        ],
        [
            15,
            15,
            1.0
        ],
        [
            16,
            15,
            0.97
        ],
        [
            17,
            15,
            0.881
        ],
        [
            18,
            15,
            0.884
        ],
        [
            19,
            15,
            0.883
        ],
        [
            20,
            15,
            0.878
        ],
        [
            0,
            16,
            0.776
        ],
        [
            1,
            16,
            0.699
        ],
        [
            2,
            16,
            0.65
        ],
        [
            3,
            16,
            0.604
        ],
        [
            4,
            16,
            0.618
        ],
        [
            5,
            16,
            0.543
        ],
        [
            6,
            16,
            0.406
        ],
        [
            7,
            16,
            0.397
        ],
        [
            8,
            16,
            0.389
        ],
        [
            9,
            16,
            0.285
        ],
        [
            10,
            16,
            0.281
        ],
        [
            11,
            16,
            0.241
        ],
        [
            12,
            16,
            0.199
        ],
        [
            13,
            16,
            0.212
        ],
        [
            14,
            16,
            0.19
        ],
        [
            15,
            16,
            0.97
        ],
        [
            16,
            16,
            1.0
        ],
        [
            17,
            16,
            0.884
        ],
        [
            18,
            16,
            0.894
        ],
        [
            19,
            16,
            0.892
        ],
        [
            20,
            16,
            0.888
        ],
        [
            0,
            17,
            0.716
        ],
        [
            1,
            17,
            0.736
        ],
        [
            2,
            17,
            0.687
        ],
        [
            3,
            17,
            0.552
        ],
        [
            4,
            17,
            0.565
        ],
        [
            5,
            17,
            0.575
        ],
        [
            6,
            17,
            0.364
        ],
        [
            7,
            17,
            0.345
        ],
        [
            8,
            17,
            0.347
        ],
        [
            9,
            17,
            0.254
        ],
        [
            10,
            17,
            0.251
        ],
        [
            11,
            17,
            0.268
        ],
        [
            12,
            17,
            0.179
        ],
        [
            13,
            17,
            0.189
        ],
        [
            14,
            17,
            0.172
        ],
        [
            15,
            17,
            0.881
        ],
        [
            16,
            17,
            0.884
        ],
        [
            17,
            17,
            1.0
        ],
        [
            18,
            17,
            0.813
        ],
        [
            19,
            17,
            0.823
        ],
        [
            20,
            17,
            0.818
        ],
        [
            0,
            18,
            0.894
        ],
        [
            1,
            18,
            0.804
        ],
        [
            2,
            18,
            0.759
        ],
        [
            3,
            18,
            0.713
        ],
        [
            4,
            18,
            0.727
        ],
        [
            5,
            18,
            0.638
        ],
        [
            6,
            18,
            0.49
        ],
        [
            7,
            18,
            0.477
        ],
        [
            8,
            18,
            0.473
        ],
        [
            9,
            18,
            0.352
        ],
        [
            10,
            18,
            0.347
        ],
        [
            11,
            18,
            0.299
        ],
        [
            12,
            18,
            0.241
        ],
        [
            13,
            18,
            0.259
        ],
        [
            14,
            18,
            0.23
        ],
        [
            15,
            18,
            0.884
        ],
        [
            16,
            18,
            0.894
        ],
        [
            17,
            18,
            0.813
        ],
        [
            18,
            18,
            1.0
        ],
        [
            19,
            18,
            0.963
        ],
        [
            20,
            18,
            0.965
        ],
        [
            0,
            19,
            0.896
        ],
        [
            1,
            19,
            0.81
        ],
        [
            2,
            19,
            0.77
        ],
        [
            3,
            19,
            0.715
        ],
        [
            4,
            19,
            0.729
        ],
        [
            5,
            19,
            0.647
        ],
        [
            6,
            19,
            0.482
        ],
        [
            7,
            19,
            0.468
        ],
        [
            8,
            19,
            0.466
        ],
        [
            9,
            19,
            0.344
        ],
        [
            10,
            19,
            0.34
        ],
        [
            11,
            19,
            0.301
        ],
        [
            12,
            19,
            0.236
        ],
        [
            13,
            19,
            0.252
        ],
        [
            14,
            19,
            0.226
        ],
        [
            15,
            19,
            0.883
        ],
        [
            16,
            19,
            0.892
        ],
        [
            17,
            19,
            0.823
        ],
        [
            18,
            19,
            0.963
        ],
        [
            19,
            19,
            1.0
        ],
        [
            20,
            19,
            0.965
        ],
        [
            0,
            20,
            0.898
        ],
        [
            1,
            20,
            0.812
        ],
        [
            2,
            20,
            0.771
        ],
        [
            3,
            20,
            0.722
        ],
        [
            4,
            20,
            0.737
        ],
        [
            5,
            20,
            0.648
        ],
        [
            6,
            20,
            0.497
        ],
        [
            7,
            20,
            0.486
        ],
        [
            8,
            20,
            0.482
        ],
        [
            9,
            20,
            0.361
        ],
        [
            10,
            20,
            0.356
        ],
        [
            11,
            20,
            0.311
        ],
        [
            12,
            20,
            0.249
        ],
        [
            13,
            20,
            0.267
        ],
        [
            14,
            20,
            0.239
        ],
        [
            15,
            20,
            0.878
        ],
        [
            16,
            20,
            0.888
        ],
        [
            17,
            20,
            0.818
        ],
        [
            18,
            20,
            0.965
        ],
        [
            19,
            20,
            0.965
        ],
        [
            20,
            20,
            1.0
        ]
    ]
}
export default S36_CotyledonHeatMap